import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";

import Layout from "./components/Layout/Layout";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import MediaCenter from "./pages/MediaCenter/MediaCenter";
import Contact from "./pages/Contact/Contact";
import Investments from "./pages/investments/Investments";

import Governance from "./pages/Governance/Governance";
import Policies from "./pages/Governance/Policies";
import BoardMinutes from "./pages/Governance/BoardMinutes";
import Regulations from "./pages/Governance/Regulations";
import FinancialStatements from "./pages/Governance/FinancialStatements";
import AnnualReports from "./pages/Governance/AnnualReports";

import Management from "./pages/Management/Management";
import Board from "./pages/Management/Board";
import CEO from "./pages/Management/CEO";
import OrgStructure from "./pages/Management/OrgStructure";

import ScrollToTop from "./components/ScrollToTop";
import LoadingScreen from "./components/loadingscreen/loading";

export default function App() {
  const [minTimeDone, setMinTimeDone] = useState(false);
  const [videosReady, setVideosReady] = useState(false);

  const [progress, setProgress] = useState(0);

  /* ⏱️ شرط 3 ثواني */
  useEffect(() => {
    const timer = setTimeout(() => {
      setMinTimeDone(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  /* 🎥 انتظار تحميل الفيديو */
useEffect(() => {
  const video = document.createElement("video");
  video.src = "/media/landing.mp4";
  video.preload = "auto";

  const updateProgress = () => {
    if (video.buffered.length > 0) {
      const bufferedEnd = video.buffered.end(video.buffered.length - 1);
      const duration = video.duration || 1;
      const percent = Math.min((bufferedEnd / duration) * 100, 100);
      setProgress(Math.floor(percent));
    }
  };

  const onReady = () => {
    setProgress(100);
    setVideosReady(true);
  };

  video.addEventListener("progress", updateProgress);
  video.addEventListener("canplaythrough", onReady);
  video.load();

  return () => {
    video.removeEventListener("progress", updateProgress);
    video.removeEventListener("canplaythrough", onReady);
  };
}, []);


  /* ❌ لا نغلق اللودينق إلا لو الاثنين جاهزين */
  const showLoading = !(minTimeDone && videosReady);

  if (showLoading) {
    return <LoadingScreen progress={progress} />

  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/media-center" element={<MediaCenter />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/investments" element={<Investments />} />

          <Route path="/governance" element={<Governance />} />
          <Route path="/governance/policies" element={<Policies />} />
          <Route path="/governance/board-minutes" element={<BoardMinutes />} />
          <Route path="/governance/regulations" element={<Regulations />} />
          <Route path="/governance/financial-statements" element={<FinancialStatements />} />
          <Route path="/governance/annual-reports" element={<AnnualReports />} />

          <Route path="/management" element={<Management />} />
          <Route path="/management/board" element={<Board />} />
          <Route path="/management/ceo" element={<CEO />} />
          <Route path="/management/org-structure" element={<OrgStructure />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
